import { useEffect } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { useNotificationStore } from '@/common';
import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { UpdateAddressReq, UpdateAddressRes } from './types';

const updateAddress = (variables: {
  customerId: string;
  addressId: string;
  address: UpdateAddressReq;
}) => {
  const { address, addressId, customerId } = variables;
  return axios<
    UpdateAddressRes,
    BaseResponse<UpdateAddressRes, UpdateAddressReq>,
    UpdateAddressReq
  >({
    url: `/customers/${customerId}/addresses/${addressId}`,
    method: 'put',
    data: address,
  });
};

export const useUpdateCustomerAddress = () => {
  const { addNotification } = useNotificationStore();
  const queryClient = useQueryClient();

  const { mutate, isLoading, isSuccess, error } = useMutation(updateAddress, {
    onSuccess: () => {
      queryClient.invalidateQueries('customer-addresses');
      queryClient.invalidateQueries('userAddresses');
      addNotification({
        title: 'Address updated!',
        type: 'success',
      });
    },
  });

  useEffect(() => {
    displayError(error);
  }, [error]);

  return {
    updateCustomerAddress: mutate,
    isLoading,
    isSuccess,
  };
};
